<app-spinner></app-spinner>
<div
	class="font-avertareguler w-full h-screen px-2 md:p-2 space-y-2 bg-white/[60%] dark:bg-slate-900/60 relative"
>
	<div class="flex">
		<h2
			class="text-[#102030] text-[15px] md:text-[18px] font-avertaBold dark:text-white"
		>
			Profile Options
		</h2>
	</div>
	<!-- class="space-y-4 popBody scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll" -->
	<div class="space-y-2">
		<mat-tab-group
			[selectedIndex]="selectedTab"
			(selectedTabChange)="changeTab($event)"
			disablePagination="true"
		>
			<!-- Defaults tab -->
			<mat-tab label="Defaults">
				<div
					class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll"
				>
					<form [formGroup]="profileForm">
						<div class="py-4">
							<div class="flex flex-col md:flex-row gap-6">
								<!-- Review Screen Defaults Card -->
								<div
									class="flex-1 bg-white dark:bg-gray-800 p-5 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 transition-colors duration-200"
								>
									<h3
										class="text-lg font-avertaSemibold mb-4 text-gray-700 dark:text-gray-200"
									>
										Review Screen Defaults
									</h3>
									<div class="space-y-3">
										<div>
											<mat-checkbox
												class="example-margin"
												formControlName="profileType1"
												color="primary"
											>
												<span
													class="text-gray-800 dark:text-gray-300"
												>
													<span
														class="font-avertareguler"
														>All By Date</span
													>
												</span>
											</mat-checkbox>
										</div>
										<div>
											<mat-checkbox
												class="example-margin"
												formControlName="profileType2"
												color="primary"
											>
												<span
													class="text-gray-800 dark:text-gray-300"
												>
													<span
														class="font-avertareguler"
														>View Details</span
													>
												</span>
											</mat-checkbox>
										</div>
										<div>
											<mat-checkbox
												class="example-margin"
												formControlName="profileType4"
												color="primary"
											>
												<span
													class="text-gray-800 dark:text-gray-300"
												>
													<span
														class="font-avertareguler"
														>Direct only ⟫ All</span
													>
												</span>
											</mat-checkbox>
										</div>
										<div>
											<mat-checkbox
												class="example-margin"
												formControlName="profileType6"
												color="primary"
											>
												<span
													class="text-gray-800 dark:text-gray-300"
												>
													<span
														class="font-avertareguler"
														>Emp set me as
														Supervisor</span
													>
												</span>
											</mat-checkbox>
										</div>
									</div>
								</div>

								<!-- RMS Display Theme Card -->
								<div
									class="flex-1 bg-white dark:bg-gray-800 p-5 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 transition-colors duration-200"
								>
									<h3
										class="text-lg font-avertaSemibold mb-4 text-gray-700 dark:text-gray-200"
									>
										RMS Display Theme
									</h3>
									<div
										class="flex flex-col sm:flex-row sm:items-center gap-3"
									>
										<label
											class="text-sm font-avertaSemibold text-gray-600 dark:text-gray-400"
										>
											Theme
										</label>
										<app-select-dropdown
											[options]="themes"
											formControlName="profileType3"
											placeholder="Select Theme"
											[searchable]="false"
											[minWidth]="'120px'"
										></app-select-dropdown>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</mat-tab>

			<!-- Groups tab -->
			<mat-tab *ngIf="isSupervisor" label="Groups">
				<div
					class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll"
				>
					<div class="py-4 px-2">
						<div class="space-y-4">
							<!-- Action Bar with improved styling -->
							<div
								class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md border border-gray-200 dark:border-gray-700"
							>
								<!-- Dropdown Section -->
								<div class="flex-1 min-w-0">
									<app-select-dropdown
										[options]="groupsOptions"
										[(ngModel)]="selectedGroupId"
										(selectionChange)="
											onGroupSelectionChange($event)
										"
										placeholder="Select Group"
										[searchable]="true"
										[clearable]="true"
									></app-select-dropdown>
								</div>

								<!-- Action Buttons -->
								<div
									class="flex items-center gap-2 flex-shrink-0"
								>
									<!-- Add Button -->
									<button
										class="flex items-center justify-center w-10 h-10 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-700 rounded-lg text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-900/50 transition-all duration-200 hover:scale-105"
										(click)="toggleAddGroupPopup()"
										title="Add Group"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											class="w-5 h-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M12 4.5v15m7.5-7.5h-15"
											/>
										</svg>
									</button>

									<!-- Edit Button -->
									<button
										class="flex items-center justify-center w-10 h-10 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-all duration-200 hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100"
										[disabled]="
											!selectedGroupId ||
											selectedGroupId == 0
										"
										(click)="toggleEditGroupPopup()"
										title="Edit Group"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											class="w-5 h-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
											/>
										</svg>
									</button>

									<!-- Delete Button -->
									<button
										class="flex items-center justify-center w-10 h-10 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 rounded-lg text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/50 transition-all duration-200 hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100"
										[disabled]="
											!selectedGroupId ||
											selectedGroupId == 0
										"
										(click)="deleteGroup()"
										title="Delete Group"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											class="w-5 h-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
											/>
										</svg>
									</button>
								</div>
							</div>

							<!-- Employees Section -->
							<div
								class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden"
								style="height: calc(100vh - 280px)"
							>
								<!-- Header -->
								<div
									class="bg-gradient-to-r from-blue-500 to-indigo-500 dark:from-gray-700 dark:to-gray-800 px-4 py-3 border-b border-gray-200 dark:border-gray-700"
								>
									<h3
										class="text-sm font-bold text-white uppercase tracking-wider"
									>
										Employees
									</h3>
								</div>

								<!-- Employee List Container -->
								<div
									class="p-3 h-[calc(100%-60px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 scrollbar-track-transparent"
								>
									<!-- Select All Checkbox -->
									<label
										class="flex items-center gap-3 p-3 mb-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-all"
									>
										<input
											type="checkbox"
											[checked]="allGroupComplete"
											[indeterminate]="
												someCompleteGroupTask()
											"
											(change)="
												setAllGroupTask(
													$event.target.checked
												)
											"
											class="w-5 h-5 rounded border-2 border-blue-500 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer transition-all"
										/>
										<span
											class="font-semibold text-gray-900 dark:text-white text-sm"
										>
											{{ groupTask.name }}
										</span>
									</label>

									<!-- Employee List -->
									<div class="space-y-1">
										<label
											*ngFor="
												let subtask of groupTask.subtasks
											"
											class="flex items-center gap-3 p-2.5 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-all duration-150 border border-transparent hover:border-gray-200 dark:hover:border-gray-600"
										>
											<input
												type="checkbox"
												[(ngModel)]="subtask.completed"
												(change)="
													onGroupItemClick(
														$event.target.checked,
														subtask
													)
												"
												class="w-4 h-4 rounded border-2 border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer transition-all"
											/>
											<span
												class="text-sm text-gray-700 dark:text-gray-300 font-medium"
											>
												{{ subtask.name }}
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-tab>

			<!-- Review Groups tab -->
			<mat-tab *ngIf="isSupervisor || isReviewer" label="Review Groups">
				<div
					class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll"
				>
					<div class="py-4 px-2">
						<div class="space-y-4">
							<!-- Action Bar -->
							<div
								class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md border border-gray-200 dark:border-gray-700"
							>
								<!-- Dropdown Section -->
								<div class="flex-1 min-w-0">
									<app-select-dropdown
										[options]="reviewGroupsOptions"
										[(ngModel)]="selectedReviewGroupId"
										(selectionChange)="
											onReviewGroupSelectionChange($event)
										"
										placeholder="Select Reviewer..."
										[searchable]="true"
										[clearable]="true"
									></app-select-dropdown>
								</div>

								<!-- Action Buttons -->
								<div
									class="flex items-center gap-2 flex-shrink-0"
								>
									<!-- Add Button (Supervisor only) -->
									<button
										*ngIf="isSupervisor"
										class="flex items-center justify-center w-10 h-10 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-700 rounded-lg text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-900/50 transition-all duration-200 hover:scale-105"
										(click)="toggleAddReviewGroupPopup()"
										title="Add Reviewer"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											class="w-5 h-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M12 4.5v15m7.5-7.5h-15"
											/>
										</svg>
									</button>

									<!-- Delete Button (Supervisor only) -->
									<button
										*ngIf="isSupervisor"
										class="flex items-center justify-center w-10 h-10 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 rounded-lg text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/50 transition-all duration-200 hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100"
										(click)="deleteReviewGroup()"
										[disabled]="
											!selectedReviewGroupId ||
											selectedReviewGroupId == 0
										"
										title="Delete Review Group"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											class="w-5 h-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
											/>
										</svg>
									</button>
								</div>
							</div>

							<!-- Employees Section -->
							<div
								class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden"
								style="height: calc(100vh - 280px)"
							>
								<!-- Header -->
								<div
									class="bg-gradient-to-r from-blue-500 to-indigo-500 dark:from-gray-700 dark:to-gray-800 px-4 py-3 border-b border-gray-200 dark:border-gray-700"
								>
									<h3
										class="text-sm font-bold text-white uppercase tracking-wider"
									>
										Employees
									</h3>
								</div>

								<!-- Employee List Container -->
								<div
									class="p-3 h-[calc(100%-60px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 scrollbar-track-transparent"
								>
									<!-- Select All Checkbox -->
									<label
										class="flex items-center gap-3 p-3 mb-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-all"
									>
										<input
											type="checkbox"
											[checked]="allReviewGroupComplete"
											[indeterminate]="
												someCompleteReviewGroupTask()
											"
											(change)="
												setAllReviewGroupTask(
													$event.target.checked
												)
											"
											class="w-5 h-5 rounded border-2 border-blue-500 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer transition-all"
										/>
										<span
											class="font-semibold text-gray-900 dark:text-white text-sm"
										>
											{{ reviewGroupTask.name }}
										</span>
									</label>

									<!-- Employee List -->
									<div class="space-y-1">
										<label
											*ngFor="
												let reviewSubtasks of reviewGroupTask.reviewSubtasks
											"
											class="flex items-center gap-3 p-2.5 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-all duration-150 border border-transparent hover:border-gray-200 dark:hover:border-gray-600"
										>
											<input
												type="checkbox"
												[(ngModel)]="
													reviewSubtasks.completed
												"
												(change)="
													onReviewGroupItemClick(
														$event.target.checked,
														reviewSubtasks
													)
												"
												class="w-4 h-4 rounded border-2 border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer transition-all"
											/>
											<span
												class="text-sm text-gray-700 dark:text-gray-300 font-medium"
											>
												{{ reviewSubtasks.name }}
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-tab>

			@if (isMaintenanceUser) {
				<!-- Maintenance tab -->
				<mat-tab label="Maintenance">
					<div
						class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll space-x-reverse"
					>
						<div class="py-4">
							<div class="space-y-6">
								<maintenance
									(formStatus)="
										checkMaintenanceFormState($event)
									"
									(citiworksIntegration)="
										checkCitiworksIntegration($event)
									"
									(ptoIntegration)="
										checkPTOIntegration($event)
									"
									(cityworksAdminUserListUpdated)="
										onCityworksAdminUserListUpdated($event)
									"
								/>
							</div>
						</div>
					</div>
				</mat-tab>
			}

			@if (shouldShowCityworksAdminTab()) {
				<mat-tab label="Cityworks Admin">
					<div
						class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll space-x-reverse"
					>
						<div class="py-4">
							<div class="space-y-6">
								<app-citiworks-admin></app-citiworks-admin>
							</div>
						</div>
					</div>
				</mat-tab>
			}
			@if (isMaintenanceUser) {
				<mat-tab label="Email configuration">
					<div
						class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll space-x-reverse"
					>
						<div class="py-4">
							<div class="space-y-6">
								<app-smtp-configuration
									(formStatus)="checkSmtpFormState($event)"
								></app-smtp-configuration>
							</div>
						</div>
					</div>
				</mat-tab>
			}
			@if (isPTOIntegration && isMaintenanceUser) {
				<mat-tab label="PTO Settings">
					<div
						class="profile-content scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll space-x-reverse"
					>
						<div class="py-4">
							<div class="space-y-6">
								<app-pto-setting
									(formStatus)="checkPtoFormState($event)"
								></app-pto-setting>
							</div>
						</div>
					</div>
				</mat-tab>
			}
		</mat-tab-group>
	</div>
	<div class="flex justify-end items-center w-full popFooter gap-2">
		<button
			class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-[#dddddd] text-[#1F74EC] flex items-center dark:bg-white/20 dark:text-white"
			(click)="closeProfileDialog()"
		>
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</span>
			<span>Close</span>
		</button>
		@if (isCurrentTab('Defaults')) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				(click)="saveSettings()"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
		@if (isCurrentTab('Groups') && isSupervisor) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				(click)="saveGroupEmployees()"
				[disabled]="!selectedGroupId || selectedGroupId == 0"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
		@if (isCurrentTab('Review Groups')) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				(click)="saveReviewGroupEmployees()"
				[disabled]="
					!selectedReviewGroupId || selectedReviewGroupId == 0
				"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
		@if (isMaintenanceUser && isCurrentTab('Maintenance')) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				[ngClass]="{
					'bg-gradient-to-t from-[#184900] to-[#39B300]':
						isMaintenanceFormDirty,
					'bg-gray-600': !isMaintenanceFormDirty
				}"
				(click)="saveMaintenanceData()"
				[disabled]="!isMaintenanceFormDirty"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
		@if (isCurrentTab('PTO Settings')) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				[ngClass]="{
					'bg-gradient-to-t from-[#184900] to-[#39B300]':
						isPTOFormDirty,
					'bg-gray-600': !isPTOFormDirty
				}"
				(click)="savePtoSetting()"
				[disabled]="!isPTOFormDirty"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
		@if (isMaintenanceUser && isCurrentTab('Email configuration')) {
			<button
				class="py-2 px-3 space-x-2 rounded-full text-[16px] bg-gradient-to-t from-[#184900] to-[#39B300] text-[#ffffff] flex items-center"
				(click)="saveSmtpConfiguration()"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 21V13H7V21"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M7 3V8H15"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		}
	</div>
	<button
		(click)="closeProfileDialog()"
		type="button"
		class="absolute right-[5px] mt-2 top-[-2px] h-8 w-8 rounded-full border border-gray-300 flex justify-center items-center bg-gray-100 text-red dark:bg-white/20 dark:text-white hover:bg-red-300 hover:text-white"
	>
		<span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="w-6 h-6"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M6 18L18 6M6 6l12 12"
				/>
			</svg>
		</span>
	</button>
</div>

<!-- Add Group Popup -->
<div
	*ngIf="showAddGroupPopup"
	class="createGrp-User fixed left-0 top-0 w-full h-screen z-10 flex items-center justify-center font-avertareguler"
>
	<div
		class="p-6 rounded-xl w-11/12 md:w-4/12 space-y-4 relative z-20 shadow-2xl bg-white/[67%] dark:bg-slate-900/60"
	>
		<div class="font-avertaBold text-[20px] dark:text-white">Add Group</div>
		<div>
			<label
				class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
			>
				Group Name
			</label>
			<div class="relative">
				<input
					type="text"
					[(ngModel)]="groupName"
					placeholder="Enter group name"
					class="w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-colors"
				/>
				<button
					*ngIf="groupName"
					type="button"
					class="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
					(click)="groupName = ''"
					aria-label="Clear"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						class="w-5 h-5"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
			</div>
		</div>
		<div class="flex justify-between items-center w-full popFooter">
			<button
				type="button"
				class="py-3 px-6 space-x-1 rounded-full text-[16px] bg-[#dddddd] text-[#1F74EC] flex items-center dark:bg-white/20 dark:text-white"
				(click)="toggleAddGroupPopup()"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</span>
				<span>Close</span>
			</button>
			<button
				type="submit"
				class="py-2 px-3 space-x-1 rounded-full text-[16px] bg-[#010D58] text-[#ffffff] flex items-center dark:bg-gray-950 border-2 border-white disabled:opacity-50 disabled:cursor-not-allowed"
				(click)="saveGroup()"
				[disabled]="!groupName"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M4.5 12.75l6 6 9-13.5"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		</div>
	</div>
</div>

<!-- Edit Group Popup -->
<div
	*ngIf="showEditGroupPopup"
	class="createGrp-User fixed left-0 top-0 w-full h-screen z-10 flex items-center justify-center font-avertareguler"
>
	<div
		class="p-6 rounded-xl w-11/12 md:w-4/12 space-y-4 relative z-20 shadow-2xl bg-white/[67%] dark:bg-slate-900/60"
	>
		<div class="font-avertaBold text-[20px] dark:text-white">
			Edit Group
		</div>
		<div>
			<label
				class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
			>
				Group Name
			</label>
			<div class="relative">
				<input
					type="text"
					[(ngModel)]="editGroupName"
					[value]="editGroupName"
					placeholder="Enter group name"
					class="w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-colors"
				/>
				<button
					*ngIf="editGroupName"
					type="button"
					class="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
					(click)="editGroupName = ''"
					aria-label="Clear"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						class="w-5 h-5"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
			</div>
		</div>
		<div class="flex justify-between items-center w-full popFooter">
			<button
				type="button"
				class="py-2 px-3 space-x-1 rounded-full text-[16px] bg-[#dddddd] text-[#1F74EC] flex items-center dark:bg-white/20 dark:text-white"
				(click)="toggleEditGroupPopup()"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</span>
				<span>Close</span>
			</button>
			<button
				type="submit"
				class="py-2 px-3 space-x-1 rounded-full text-[16px] bg-[#010D58] text-[#ffffff] flex items-center dark:bg-gray-950 border-2 border-white disabled:opacity-50 disabled:cursor-not-allowed"
				(click)="updateGroup()"
				[disabled]="!editGroupName"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M4.5 12.75l6 6 9-13.5"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		</div>
	</div>
</div>

<!-- Add Review Group Popup -->
<div
	*ngIf="showAddReviewGroupPopup"
	class="createGrp-User fixed left-0 top-0 w-full h-screen z-10 flex items-center justify-center font-avertareguler"
>
	<div
		class="p-6 rounded-xl w-11/12 md:w-4/12 space-y-4 relative z-20 shadow-2xl bg-white/[67%] dark:bg-slate-900/60"
	>
		<div class="font-avertaBold text-[20px] dark:text-white">
			Add Reviewer
		</div>
		<div>
			<label
				class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
			>
				Select Reviewer...
			</label>
			<app-select-dropdown
				[options]="reviewersOptions"
				[(ngModel)]="reviewer"
				placeholder="Select Reviewer..."
				[searchable]="true"
				[clearable]="true"
			></app-select-dropdown>
			@if (reviewersList?.length === 0) {
				<p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
					No reviewer available
				</p>
			}
		</div>
		<div class="flex justify-between items-center w-full popFooter">
			<button
				type="button"
				class="py-3 px-6 space-x-1 rounded-full text-[16px] bg-[#dddddd] text-[#1F74EC] flex items-center dark:bg-white/20 dark:text-white"
				(click)="toggleAddReviewGroupPopup()"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</span>
				<span>Close</span>
			</button>
			<button
				type="submit"
				class="py-2 px-3 space-x-1 rounded-full text-[16px] bg-[#010D58] text-[#ffffff] flex items-center dark:bg-gray-950 border-2 border-white disabled:opacity-50 disabled:cursor-not-allowed"
				(click)="saveReviewGroup()"
				[disabled]="!reviewer"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M4.5 12.75l6 6 9-13.5"
						/>
					</svg>
				</span>
				<span>SAVE</span>
			</button>
		</div>
	</div>
</div>
